import * as THREE from 'three'
import { scene, incRenderCount } from './mobilPhoneShell'
import TextDrawer from './textDrawer';

export let currentMesh;
export let currentGroup;
let currentDraw = {
    width: 100,
    image: null,
};
let currentBaseBegin;

const canvas2 = document.createElement("canvas");
const context2 = canvas2.getContext("2d");

let textDrawer = new TextDrawer(canvas2, context2);

const redColorArr = new Float32Array(256);
for (let i = 0; i <= 255; i++) {
    redColorArr[i] = i * 0.299 / 255;
}
const greenColorArr = new Float32Array(256);
for (let i = 0; i <= 255; i++) {
    greenColorArr[i] = i * 0.587 / 255;
}
const blueColorArr = new Float32Array(256);
for (let i = 0; i <= 255; i++) {
    blueColorArr[i] = i * 0.114 / 255;
}
const greyColorArr = new Float32Array(256);
for (let i = 0; i <= 255; i++) {
    greyColorArr[i] = i / 255;
}

// 纵向排列的
function getVertexIndexV(r, c, hRange) {
    return c * hRange + r;
}

function imgToModel(draw) {
    let { w, h, h2, paddingRealLeftRight, paddingRealTopBottom, cellSize, data } = makeDataForModel(draw);

    // 添加点
    let height = draw.height2;
    let halfWidth = draw.width * 0.5;
    let halfHeight = height * 0.5;

    // 计算点的数量
    let wRange = w + 2;
    let hRange = h + 2;
    let n_vertices = wRange * hRange + 8;
    let vertices = new Float32Array(n_vertices * 3);

    // console.time("pixel2depth", isGray);
    // 中间的变化点
    let left = paddingRealLeftRight - halfWidth;
    let v_index = 0;
    for (let i = -1; i <= w; i++) {
        let top = paddingRealTopBottom - halfHeight;
        for (let j = -1; j <= h; j++) {
            let grey = 0;
            if (i >= 0 && i < w && j >= 0 && j < h) {
                let index = (j * w + i) * 4;
                grey = redColorArr[data.data[index]] + greenColorArr[data.data[index + 1]] + blueColorArr[data.data[index + 2]];
                if (j < h2) {
                    let t = data.data[index + 3] / 255;
                    grey *= t;
                }
            }
            vertices[v_index] = left;
            vertices[v_index + 1] = grey;
            vertices[v_index + 2] = top;
            top += cellSize;
            v_index += 3;
        }
        left += cellSize;
    }
    // console.timeEnd("pixel2depth");
    // 四个顶点
    let aIndex = v_index / 3;
    vertices[v_index] = -halfWidth;
    vertices[v_index + 1] = 0;
    vertices[v_index + 2] = -halfHeight;
    v_index += 3;
    let bIndex = aIndex + 1;
    vertices[v_index] = -halfWidth;
    vertices[v_index + 1] = 0;
    vertices[v_index + 2] = halfHeight;
    v_index += 3;
    let cIndex = bIndex + 1;
    vertices[v_index] = halfWidth;
    vertices[v_index + 1] = 0;
    vertices[v_index + 2] = halfHeight;
    v_index += 3;
    let dIndex = cIndex + 1;
    vertices[v_index] = halfWidth;
    vertices[v_index + 1] = 0;
    vertices[v_index + 2] = -halfHeight;
    v_index += 3;

    // 三角形
    let n_tris = (wRange - 1) * (hRange - 1) * 2;
    n_tris += (wRange + hRange) * 2;
    n_tris += 10;
    let indices = new Array(n_tris * 3);
    let i_index = 0;
    for (let i = 0; i < wRange - 1; i++) {
        for (let j = 0; j < hRange - 1; j++) {
            let a = getVertexIndexV(j, i, hRange); // i * hRange + j; // i, j
            let b = getVertexIndexV(j + 1, i, hRange); // i * hRange + j + 1; // i, j + 1
            let c = getVertexIndexV(j + 1, i + 1, hRange); // (i + 1) * hRange + j + 1; // i + 1, j + 1
            let d = getVertexIndexV(j, i + 1, hRange); // (i + 1) * hRange + j; // i + 1, j
            indices[i_index] = a;
            indices[i_index + 1] = b;
            indices[i_index + 2] = c;
            i_index += 3;
            indices[i_index] = a;
            indices[i_index + 1] = c;
            indices[i_index + 2] = d;
            i_index += 3;
        }
    }

    indices[i_index] = aIndex;
    indices[i_index + 1] = bIndex;
    indices[i_index + 2] = getVertexIndexV(0, 0, hRange);
    i_index += 3;
    for (let i = 1; i < hRange; i++) {
        let a = getVertexIndexV(i - 1, 0, hRange); // i - 1;
        let b = getVertexIndexV(i, 0, hRange); // i;
        indices[i_index] = b;
        indices[i_index + 1] = a;
        indices[i_index + 2] = bIndex;
        i_index += 3;
    }
    indices[i_index] = bIndex;
    indices[i_index + 1] = cIndex;
    indices[i_index + 2] = getVertexIndexV(hRange - 1, 0, hRange);
    i_index += 3;
    for (let i = 1; i < wRange; i++) {
        let b = getVertexIndexV(hRange - 1, i, hRange); // wRange * (hRange - 1) + i;
        let a = getVertexIndexV(hRange - 1, i - 1, hRange);
        indices[i_index] = b;
        indices[i_index + 1] = a;
        indices[i_index + 2] = cIndex;
        i_index += 3;
    }
    indices[i_index] = cIndex;
    indices[i_index + 1] = dIndex;
    indices[i_index + 2] = getVertexIndexV(hRange - 1, wRange - 1, hRange);
    i_index += 3;
    for (let i = hRange - 1; i >= 1; i--) {
        let a = getVertexIndexV(i, wRange - 1, hRange); // wRange * (i - 1) + wRange - 1;
        let b = getVertexIndexV(i - 1, wRange - 1, hRange); // wRange * i + wRange - 1;
        indices[i_index] = b;
        indices[i_index + 1] = a;
        indices[i_index + 2] = dIndex;
        i_index += 3;
    }
    indices[i_index] = dIndex;
    indices[i_index + 1] = aIndex;
    indices[i_index + 2] = getVertexIndexV(0, wRange - 1, hRange);
    i_index += 3;
    for (let i = wRange - 1; i >= 1; i--) {
        let a = getVertexIndexV(0, i, hRange); // wRange * (i - 1) + wRange - 1;
        let b = getVertexIndexV(0, i - 1, hRange); // wRange * i + wRange - 1;
        indices[i_index] = b;
        indices[i_index + 1] = a;
        indices[i_index + 2] = aIndex;
        i_index += 3;
    }

    // 下面的点：四个点
    let downY = -draw.thickness;
    vertices[v_index] = -halfWidth;
    vertices[v_index + 1] = downY;
    vertices[v_index + 2] = -halfHeight;
    v_index += 3;
    vertices[v_index] = -halfWidth;
    vertices[v_index + 1] = downY;
    vertices[v_index + 2] = halfHeight;
    v_index += 3;
    vertices[v_index] = halfWidth;
    vertices[v_index + 1] = downY;
    vertices[v_index + 2] = halfHeight;
    v_index += 3;
    vertices[v_index] = halfWidth;
    vertices[v_index + 1] = downY;
    vertices[v_index + 2] = -halfHeight;
    v_index += 3;
    let aDownIndex = dIndex + 1;
    let bDownIndex = aDownIndex + 1;
    let cDownIndex = bDownIndex + 1;
    let dDownIndex = cDownIndex + 1;

    // 四个壁
    indices[i_index] = aIndex;
    indices[i_index + 1] = aDownIndex;
    indices[i_index + 2] = bDownIndex;
    i_index += 3;
    indices[i_index] = aIndex;
    indices[i_index + 1] = bDownIndex;
    indices[i_index + 2] = bIndex;
    i_index += 3;
    // 对于类型一支柱，下面的面去除
    indices[i_index] = bIndex;
    indices[i_index + 1] = bDownIndex;
    indices[i_index + 2] = cDownIndex;
    i_index += 3;
    indices[i_index] = bIndex;
    indices[i_index + 1] = cDownIndex;
    indices[i_index + 2] = cIndex;
    i_index += 3;
    indices[i_index] = cIndex;
    indices[i_index + 1] = cDownIndex;
    indices[i_index + 2] = dDownIndex;
    i_index += 3;
    indices[i_index] = cIndex;
    indices[i_index + 1] = dDownIndex;
    indices[i_index + 2] = dIndex;
    i_index += 3;
    indices[i_index] = dIndex;
    indices[i_index + 1] = dDownIndex;
    indices[i_index + 2] = aDownIndex;
    i_index += 3;
    indices[i_index] = dIndex;
    indices[i_index + 1] = aDownIndex;
    indices[i_index + 2] = aIndex;
    i_index += 3;

    // 构造底
    indices[i_index] = aDownIndex;
    indices[i_index + 1] = dDownIndex;
    indices[i_index + 2] = cDownIndex;
    i_index += 3;
    indices[i_index] = aDownIndex;
    indices[i_index + 1] = cDownIndex;
    indices[i_index + 2] = bDownIndex;
    i_index += 3;
    currentBaseBegin = aDownIndex;

    let geom = new THREE.BufferGeometry();
    geom.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
    geom.setIndex(indices);

    // geom = geom.toNonIndexed();
    // geom.computeVertexNormals();

    return geom;
}


function getDrawSize(draw) {
    if (!draw.image) {
        return null;
    }
    // 1. 先确定图片宽度
    let imageWidth = draw.imageWidth;
    let fontSize = draw.fontSize * imageWidth / draw.width * 0.1; // 字号
    // 2. 根据比例确定图片高度像素
    let paddingRealLeftRight = 3; // 真实边距
    let innerWidth = draw.width - paddingRealLeftRight * 2; // 真实内部宽度
    let innerHeight = draw.height2 - paddingRealLeftRight * 2; // 真实内部高度
    let cellSize = innerWidth / (imageWidth + 1); // 单元格的宽度：左右个添加一个像素，用于过渡
    let imageHeight = Math.round(innerHeight / cellSize - 1); // 计算图像高度：取整
    let paddingRealTopBottom = (draw.height2 - cellSize * (imageHeight + 1)) / 2; // 重新计算上下的边距

    let textHeight = 0;
    let textData;
    if (draw.useText) {
        canvas2.width = imageWidth;
        textData = textDrawer.breakText(draw.text, fontSize);
        textHeight = Math.round(textData.height);
    }

    return { w: imageWidth, h2: imageHeight, h: imageHeight - textHeight, paddingRealLeftRight, paddingRealTopBottom, cellSize, textData, fontSize };
}

export function makeDataForModel(draw) {
    let image = draw.image;
    let { w, h, h2, paddingRealLeftRight, paddingRealTopBottom, cellSize, textData, fontSize } = getDrawSize(draw);
    canvas2.width = w;
    canvas2.height = h2;
    context2.fillStyle = "#00000000";
    context2.fillRect(0, 0, w, h2);

    let ratio1 = w / h;
    let ratio2 = image.naturalWidth / image.naturalHeight;
    if (ratio2 > ratio1) {
        let sx = Math.round((image.naturalWidth - image.naturalHeight / h * w) / 2);
        let sw = image.naturalWidth - sx * 2;
        context2.drawImage(image, sx, 0, sw, image.naturalHeight, 0, 0, w, h);
        //console.log("makeDataForModel a", w, h, image.naturalWidth, sx, 0, sw, image.naturalHeight);
    } else if (ratio1 > ratio2) {
        let sy = Math.round((image.naturalHeight - image.naturalWidth / w * h) / 2);
        let sh = image.naturalHeight - sy * 2;
        context2.drawImage(image, 0, sy, image.naturalWidth, sh, 0, 0, w, h);
        //console.log("makeDataForModel b", 0, sy, image.naturalWidth, sh);
    } else {
        context2.drawImage(image, 0, 0, w, h);
    }

    if (draw.useText && draw.text) {
        textDrawer.drawText(textData, fontSize);
        //console.log('draw text', textData, fontSize);
    }

    let data = context2.getImageData(0, 0, w, h2);

    if (draw.blur) {
        data = meanBlur(data, draw.blur,h);
    }

    return { w, h: h2, h2: h, paddingRealLeftRight, paddingRealTopBottom, cellSize, data };
}

function meanBlur(imgData, r, h) {
    let data = imgData.data;
    let width = imgData.width;
    let height = imgData.height;
    let resultImageData = new ImageData(width, height);
    for (let i = 0; i < width; i++) {
        for (let j = 0; j < h; j++) {
            let N = 0;
            let red = 0, blue = 0, green = 0;
            for (let k = i - r; k < i + r; k++) {
                for (let l = j - r; l < j + r; l++) {
                    if (k >= 0 && k < width && l >= 0 && l < height) {
                        let index = (l * width + k) * 4;
                        // let grey = data[index] * 0.299 + data[index + 1] * 0.587 + data[index + 2] * 0.114;
                        red += data[index];
                        blue += data[index + 1];
                        green += data[index + 2];
                        N++;
                    }
                }
            }
            red /= N;
            blue /= N;
            green /= N;

            let ii = (j * width + i) * 4;
            resultImageData.data[ii] = red;
            resultImageData.data[ii + 1] = blue;
            resultImageData.data[ii + 2] = green;
            resultImageData.data[ii + 3] = data[ii + 3];
        }

        for (let j = h; j < height; j++) {
            let ii = (j * width + i) * 4;
            resultImageData.data[ii] = data[ii];
            resultImageData.data[ii + 1] = data[ii + 1];
            resultImageData.data[ii + 2] = data[ii + 2];
            resultImageData.data[ii + 3] = data[ii + 3];
        }

    }
    return resultImageData;
}

function updateReliefPartPositionAndRotation(draw) {
    // 对于浮雕部分，直接缩放即可
    currentMesh.scale.set(1.0, draw.height, 1.0);
    // 打底部分，需要修改位置
    let positionArray = currentMesh.geometry.attributes.position.array;
    let begin = currentBaseBegin * 3;
    for (let i = begin; i < positionArray.length; i += 3) {
        positionArray[i + 1] = -draw.thickness / draw.height;
    }
    currentMesh.geometry.attributes.position.needsUpdate = true;
    currentMesh.geometry.computeVertexNormals();
    // 如果弯折角度变化，需要重新计算底部
    // let { rad } = drawSize; // 倾斜
    // currentGroup.rotation.x = Math.PI * 0.3;
    currentMesh.position.z = 11;//手机壳里面的浮雕居中
    currentMesh.position.y = 0;
}

export function makeGroupIfNeeded() {
    if (!currentGroup) {
        currentGroup = new THREE.Group();
        scene.add(currentGroup);
    } else if (scene.children.indexOf(currentGroup) < 0) {
        scene.add(currentGroup);
    }
}

export function updateMesh(draw) {
    makeGroupIfNeeded();
    updateCurrentMesh(draw);
    incRenderCount();
}


function updateCurrentMesh(draw) {
    // 仔细检查每一项，确定更新方案
    // 1. 是否创建新的浮雕部分
    let createNewReliefPart = false; // 重建浮雕网格几何体
    let updateInnerPart = false; // 更新内部区域
    let updateFullPart = false; // 更新整个区域
    let size1 = getDrawSize(currentDraw); // 旧的绘制尺寸
    let size2 = getDrawSize(draw); // 新的绘制尺寸
    if (size1 === null) {
        createNewReliefPart = true;
    } else {
        if (size1.w === size2.w && size1.h2 === size2.h2) {
            if (size1.paddingRealLeftRight === size2.paddingRealLeftRight && size1.paddingRealTopBottom === size2.paddingRealTopBottom) {
                updateInnerPart = true;
            } else {
                updateFullPart = true;
            }
        } else {
            createNewReliefPart = true;
        }
    }

    //console.log(createNewReliefPart, updateInnerPart, updateFullPart, size1, size2);

    if (createNewReliefPart) {
        if (currentMesh) {
            currentGroup.remove(currentMesh);
            currentMesh.geometry.dispose();
        }
        let mesh = makeNewMesh(draw);
        currentMesh = mesh;
        currentGroup.add(currentMesh);
        //console.log("make new relief");
    } else {
        if (updateInnerPart) {
            updateMeshPosition(draw);
        } else if (updateFullPart) {
            updateMeshPosition2(draw);
        }
    }

    updateReliefPartPositionAndRotation(draw, size2);

    currentDraw.image = draw.image;
    currentDraw.width = draw.width;
    currentDraw.height = draw.height;
    currentDraw.height2 = draw.height2;
    currentDraw.thickness = draw.thickness;
    currentDraw.blur = draw.blur;
    currentDraw.useText = draw.useText;
    currentDraw.text = draw.text;
    currentDraw.fontSize = draw.fontSize;
    currentDraw.imageWidth = draw.imageWidth;
}

function updateMeshPosition(draw, isGray) {
    //console.log('updateMeshPosition');
    console.time("updateMeshPosition");
    let { w, h, h2, data } = makeDataForModel(draw);
    //console.log('w, h, data', w, h, data);

    let positionArray = currentMesh.geometry.attributes.position.array;
    let vIndex = 0;
    if (isGray) {
        for (let i = -1; i <= w; i++) {
            for (let j = -1; j <= h; j++) {
                if (i >= 0 && i < w && j >= 0 && j < h) {
                    let index = (j * w + i) * 4;
                    let grey = greyColorArr[data.data[index]];
                    positionArray[vIndex + 1] = grey;
                }
                vIndex += 3;
            }
        }
    } else {
        for (let i = -1; i <= w; i++) {
            for (let j = -1; j <= h; j++) {
                if (i >= 0 && i < w && j >= 0 && j < h) {
                    let index = (j * w + i) * 4;
                    let grey = redColorArr[data.data[index]] + greenColorArr[data.data[index + 1]] + blueColorArr[data.data[index + 2]];

                    if (j < h2) {
                        let t = data.data[index + 3] / 255;
                        grey *= t;
                    }

                    positionArray[vIndex + 1] = grey;
                }
                vIndex += 3;
            }
        }
    }

    currentMesh.geometry.attributes.position.needsUpdate = true;
    currentMesh.geometry.computeVertexNormals();

    // console.timeEnd("updateMeshPosition");
}

function updateMeshPosition2(draw, isGray) {
    //console.log('updateMeshPosition2');
    let { w, h, paddingRealLeftRight, paddingRealTopBottom, cellSize, data } = makeDataForModel(draw);

    let positionArray = currentMesh.geometry.attributes.position.array;
    let vIndex = 0;
    let left = paddingRealLeftRight - draw.width * 0.5;
    let height = draw.height2;
    let halfHeight = height * 0.5;
    //console.log("updateMeshPosition2", left, height, halfHeight);
    if (isGray) {
        for (let i = -1; i <= w; i++) {
            left += cellSize;
            let top = paddingRealTopBottom - halfHeight;
            for (let j = -1; j <= h; j++) {
                top += cellSize;
                positionArray[vIndex] = left;
                positionArray[vIndex + 2] = top;
                if (i >= 0 && i < w && j >= 0 && j < h) {
                    let index = (j * w + i) * 4;
                    let grey = greyColorArr[data.data[index]];
                    positionArray[vIndex + 1] = grey;
                }
                vIndex += 3;
            }
        }
    } else {
        for (let i = -1; i <= w; i++) {
            left += cellSize;
            let top = paddingRealTopBottom - halfHeight;
            for (let j = -1; j <= h; j++) {
                top += cellSize;
                positionArray[vIndex] = left;
                positionArray[vIndex + 2] = top;
                if (i >= 0 && i < w && j >= 0 && j < h) {
                    let index = (j * w + i) * 4;
                    let grey = redColorArr[data.data[index]] + greenColorArr[data.data[index + 1]] + blueColorArr[data.data[index + 2]];

                    if (j < h2) {
                        let t = data.data[index + 3] / 255;
                        grey *= t;
                    }

                    positionArray[vIndex + 1] = grey;
                }
                vIndex += 3;
            }
        }
    }
    positionArray[vIndex + 2] = -halfHeight;
    vIndex += 3;
    positionArray[vIndex + 2] = halfHeight;
    vIndex += 3;
    positionArray[vIndex + 2] = halfHeight;
    vIndex += 3;
    positionArray[vIndex + 2] = -halfHeight;
    vIndex += 3;
    positionArray[vIndex + 2] = -halfHeight;
    vIndex += 3;
    positionArray[vIndex + 2] = halfHeight;
    vIndex += 3;
    positionArray[vIndex + 2] = halfHeight;
    vIndex += 3;
    positionArray[vIndex + 2] = -halfHeight;
    vIndex += 3;
    currentMesh.geometry.attributes.position.needsUpdate = true;
    currentMesh.geometry.computeVertexNormals();
}

export const material = new THREE.MeshPhysicalMaterial({
    reflectivity: 0.2,
    roughness: 0.5,
    clearcoat: 1,
    flatShading: true,
    // flatShading: false,
    // transparent: true,
    // opacity: 0.5,
    // side: THREE.DoubleSide
    // vertexColors: true,
});

// window["ma"] = material;

// const material = new THREE.MeshPhongMaterial({
//     reflectivity: 0.5,
//     flatShading: true,
// });

function makeNewMesh(draw) {
    return new THREE.Mesh(imgToModel(draw), material);
}





// WEBPACK FOOTER //
// ./src/views/mobilPhoneShell3d/scripts/relief.js